var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"done-btn",attrs:{"color":"#1B93AD","fixed":"","right":"","bottom":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }